import PulseLoader from 'react-spinners/PulseLoader';

const Button = (props) => {
  return (
    <button
      type={props.type ? props.type : 'button'}
      onClick={props.type ? () => {} : () => {
        if(!props.loading){
          props.onClick()
        }
      }}
      className={`${
        props.bold ? 'font-semibold' : 'font-normal'
      } h-[40px] md:h-14  bg-red border-2 border-red w-full md:min-w-[140px]  flex space-x-2 justify-center items-center px-3 py-2 md:px-5 md:py-3 text-white rounded-xl md:rounded-2xl text-sm md:text-xl`}>
      {props.icon && (
        <img
          src={props.icon}
          className="w-5 h-5 md:w-6 md:h-6 object-contain"
          alt="icon_login"
        />
      )}

      {props.loading ? (
        <PulseLoader color={'white'} size={8} />
      ) : (
        <span>{props.label}</span>
      )}
    </button>
  );
};

export default Button;
